/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MonthPlanStateIncomeTypeDto
 */
export interface MonthPlanStateIncomeTypeDto {
  /**
   *
   * @type {string}
   * @memberof MonthPlanStateIncomeTypeDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof MonthPlanStateIncomeTypeDto
   */
  name: string;
}

export function MonthPlanStateIncomeTypeDtoFromJSON(json: any): MonthPlanStateIncomeTypeDto {
  return MonthPlanStateIncomeTypeDtoFromJSONTyped(json, false);
}

export function MonthPlanStateIncomeTypeDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MonthPlanStateIncomeTypeDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
  };
}

export function MonthPlanStateIncomeTypeDtoToJSON(value?: MonthPlanStateIncomeTypeDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name,
  };
}
